import ChangingAuthMethod from './ChangingAuthMethod';

export default ChangingAuthMethod;
